import React, {FC} from 'react';
import UIBackButton from '../UICommon/UIBackButton';
import UIHeading from '../UICommon/UIHeading';
import HealthDeclarationProgressBar from './HealthDeclarationProgressBar';

type HealthDeclarationQuestionsHeaderProps = {
  headerTitle: string,
  backButtonTitle: string,
  description: string,
  totalSteps: number,
  currentStep: number,
}

const HealthDeclarationQuestionsHeader: FC<HealthDeclarationQuestionsHeaderProps> = ({
  headerTitle,
  backButtonTitle,
  description,
  totalSteps,
  currentStep,
}) => {
  return (
    <div className='h-[20%] md:h-auto'>
      <UIHeading style='hidden md:block' title={headerTitle} description=''/>
      <UIBackButton style='md:hidden' href='/home' title={backButtonTitle}/>
      <div className='hidden md:block text-navy-primary'>{description}:</div>
      <HealthDeclarationProgressBar
        totalSteps={totalSteps}
        currentStep={currentStep}
      />
    </div>
  );
};

export default HealthDeclarationQuestionsHeader;
